import { render, staticRenderFns } from "./PublicList.vue?vue&type=template&id=268769cc"
import script from "./PublicList.vue?vue&type=script&lang=ts"
export * from "./PublicList.vue?vue&type=script&lang=ts"
import style0 from "./PublicList.vue?vue&type=style&index=0&id=268769cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports